import { render, staticRenderFns } from "./ChangeDetail.vue?vue&type=template&id=c5b2d884"
import script from "./ChangeDetail.vue?vue&type=script&lang=js"
export * from "./ChangeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports